import { LOCAL_LANGUAGE_KEY } from "constants/languages.constant";

export const getClientCountryCode = async (clientIP) => {
  return await fetch(`http://ip-api.com/json/${clientIP}`)
    .then((res) => res.json())
    .then((data) => data.countryCode || "US")
    .catch((e) => "US");
};

export const handleSetLocalLanguage = (lang) => {
  localStorage.setItem(LOCAL_LANGUAGE_KEY, lang);
};

export const getLocalLanguage = () => {
  return (
    (typeof window !== "undefined" &&
      localStorage.getItem(LOCAL_LANGUAGE_KEY)) ||
    "en"
  );
};
